module.exports = __webpack_public_path__ + "img/Dall-Mountain-Sheep.509dd0b0.png";